var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyComposition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DEF3FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#FFC79C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0172 11.1765H15.9829C13.6045 11.1765 11.6765 13.1045 11.6765 15.4828V24.5172C11.6765 26.8955 13.6045 28.8235 15.9829 28.8235H25.0172C27.3956 28.8235 29.3236 26.8955 29.3236 24.5172V15.4828C29.3236 13.1045 27.3956 11.1765 25.0172 11.1765Z",
    fill: "#121622"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1101 18.1082C21.8613 18.1855 22.5924 18.3968 23.2689 18.7323C23.4119 18.8065 23.5765 18.828 23.7338 18.7931C23.891 18.7581 24.031 18.6689 24.1291 18.5411L25.855 16.2362C25.9116 16.1719 25.9536 16.0961 25.9782 16.0141C26.0029 15.9321 26.0096 15.8457 25.9978 15.7609C25.9861 15.6761 25.9562 15.5948 25.9102 15.5225C25.8642 15.4503 25.8032 15.3888 25.7313 15.3423C24.1569 14.4159 22.3634 13.9274 20.5367 13.9274C18.71 13.9274 16.9165 14.4159 15.3421 15.3423C15.2656 15.3834 15.1987 15.4404 15.1461 15.5096C15.0935 15.5787 15.0564 15.6584 15.0372 15.7431C15.018 15.8278 15.0172 15.9157 15.0349 16.0008C15.0526 16.0858 15.0883 16.1661 15.1397 16.2362L16.6464 18.3612C16.6671 18.3907 16.6897 18.4188 16.7138 18.4456L16.8488 18.5805C16.9869 18.6977 17.1564 18.7718 17.3362 18.7938C17.516 18.8158 17.6984 18.7846 17.8607 18.7042C18.8713 18.2193 19.9932 18.0136 21.1101 18.1082Z",
    fill: "#FFC79C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3975 16.2361C22.2959 16.1886 22.1858 16.1619 22.0737 16.1577C21.9616 16.1536 21.8498 16.1719 21.7449 16.2118C21.6401 16.2516 21.5443 16.3122 21.4632 16.3897C21.3822 16.4673 21.3176 16.5604 21.2732 16.6634L20.6716 18.097C20.8234 18.097 20.9808 18.097 21.1382 18.097C21.5529 18.1486 21.9615 18.2409 22.3582 18.3725L22.8248 17.3155C22.9054 17.1151 22.906 16.8915 22.8265 16.6906C22.747 16.4898 22.5934 16.3271 22.3975 16.2361Z",
    fill: "#121622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyComposition);
export default __webpack_public_path__ + "static/media/body-composition.2149400e15efd43aa230aea8f0b00eca.svg";
export { ForwardRef as ReactComponent };